module.exports = __webpack_public_path__ + "img/body-3-lg.a39ca6dc.png";